<template>
    <div class="w-full space-y-3">
        <Head title="Project Reports"/>
        <div class="flex justify-between">
            <div class="w-full flex gap-3 justify-between">
                <div class="w-full flex gap-3">
                    <h1 class="mt-2 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl">Project Reports</h1>
                </div>
            </div>
            <div class="w-full flex justify-end justify-content-end align-items-end mr-4 gap-2">
                <a :href="route('frontend.reports.organisation-office-usage')"
                   class="cursor-pointer inline-flex items-center px-4 py-2 bg-white border border-gray-300 rounded-md font-semibold text-xs text-gray-700 uppercase hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    Office Usage Export
                </a>
                <search-filter :show-filter="false" v-model:value="form.search" class="w-1/2 max-w-md"
                                    @reset="reset"></search-filter>
            </div>
        </div>
        <div class="flex justify-between">
            <div class="w-full flex gap-3 justify-between">
                <div class="flex gap-1 w-full items-center">
                    <select id="project_status" v-model="form.filter.status"
                            :class="{'border-red-500': form.errors['filter.status']}"
                            class="mt-1 block w-2/3 bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                        <option value selected v-html="'Status'"></option>
                        <option v-for="status in filters.statuses" :value="status"
                                v-html="status.charAt(0).toUpperCase() + status.substring(1)"></option>
                    </select>

                    <select id="project_status" v-model="form.filter.organisation"
                            class="mt-1 block w-2/3 bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                        <option value selected v-html="'Client'"></option>
                        <option v-for="client in filters.clients" :value="client.id"
                                v-html="client.name"></option>
                    </select>
                    <select id="project_status" v-model="form.filter.office"
                            class="mt-1 block w-2/3 bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                        <option value selected v-html="'Office'"></option>
                        <option v-for="office in filters.offices" :value="office.id"
                                v-html="office.name"></option>
                    </select>
                    <select id="project_status" v-model="form.filter.manager"
                            class="mt-1 block w-2/3 bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                        <option value selected v-html="'Project Manager'"></option>
                        <option v-for="manager in filters.managers" :value="manager.id"
                                v-html="manager.first_name + ' ' + manager.last_name"></option>
                    </select>
                    <div class="flex items-center gap-2 w-full">
                    <input v-model="form.filter.starts_at" type="date"
                        name="starts_at" id="starts_at"
                        autocomplete="starts_at"
                        class="flex-grow-1 mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm"/>
                    </div>
                    <div class="flex items-center gap-2 w-full">
                    <input v-model="form.filter.ends_at" type="date"
                        name="ends_at" id="ends_at"
                        autocomplete="ends_at"
                        class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm"/>
                    </div>
                    <select id="project_status" v-model="form.filter.sort_by"
                            class="mt-1 block w-2/3 bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                        <option value selected v-html="'Sort by'"></option>
                        <option v-for="(sortby,index) in filters.sortby" :value="index"
                                v-html="sortby"></option>
                    </select>
                    <select id="project_status" v-model="form.filter.direction"
                            class="mt-1 block w-1/2 bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                        <option value selected v-html="'Direction'"></option>
                        <option value="asc" v-html="'Asc'"></option>
                        <option value="desc" v-html="'Desc'"></option>
                    </select>
                    <div>
                        <button @click="exportReports()" :disabled="exporting"
                            class="cursor-pointer inline-flex items-center px-6 py-2 bg-gray-500 border border-transparent rounded-md font-semibold text-xs text-white uppercase focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed">
                            <svg v-if="exporting" class="animate-spin -ml-0.5 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
                            </svg>
                            <DownloadIcon v-else class="-ml-0.5 mr-2 h-4 w-4" />
                            {{ exporting ? 'Exporting...' : 'Export' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-white py-6 px-4 sm:p-6 shadow mb-6">
            <div class="flex flex-col mt-3 space-y-3">
                <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                        <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                            <table class="min-w-full divide-y divide-gray-200">
                                <thead class="bg-gray-50">
                                <tr>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Reference
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Name
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Client
                                    </th>

                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Office
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Manager
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Date
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Status
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Currency Code
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Net Sell Total
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Gross Sell Total
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Net Buy Total
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Gross Buy Total
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Net Profit
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Gross Profit
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Profit %
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="projects.data.length > 0" v-for="(project,index) in projects.data" :key="index">
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {{ project.reference }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {{ project.title }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {{ project.client }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {{ project.office }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {{ project.manager }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {{ moment(project.starts_at, 'YYYY-MM-DD').format('DD-MM-YYYY') }}
                                            <br/>
                                            {{ moment(project.ends_at, 'YYYY-MM-DD').format('DD-MM-YYYY') }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {{ project.status }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {{ project.currency_code }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {{ formatCurrency(project.net_sell_total, project.currency_code) }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {{ formatCurrency(project.gross_sell_total, project.currency_code) }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {{ formatCurrency(project.net_buy_total, project.currency_code) }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {{ formatCurrency(project.gross_buy_total, project.currency_code) }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {{ formatCurrency(project.net_profit_total, project.currency_code) }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {{ formatCurrency(project.gross_profit_total, project.currency_code) }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {{ project.profit_percentage.toFixed(2) }}%
                                        </td>
                                    </tr>
                                    <tr v-else>
                                        <td colspan="14" class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            There are no Project Reports available.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <Pagination :links="projects.links"/>
            </div>
        </div>
    </div>
</template>

<script>
import SearchFilter from "@/Components/SearchFilter.vue";
import Authenticated from "@/Layouts/Authenticated.vue";
import Pagination from "@/Components/Pagination.vue";
import mapValues from "lodash/mapValues";
import debounce from "lodash/debounce";
import pickBy from "lodash/pickBy";
import moment from "moment/moment";
import {Link, Head, useForm} from "@inertiajs/vue3";
import {DownloadIcon} from "@heroicons/vue/outline";

export default {
    layout: Authenticated,
    components: {
        Head,
        Link,
        Pagination,
        SearchFilter,
        DownloadIcon
    },
    props: {
        projects: Object,
        filters: Object
    },
    mounted() {
    },
    created() {
      this.moment = moment;
    },
    data() {
        return {
            exporting: false,
            form: useForm({
                search: null,
                filter: {
                    status: "",
                    manager: "",
                    organisation: "",
                    project_type: "",
                    starts_at: "",
                    office: "",
                    ends_at: "",
                    sort_by: "created_at",
                    direction: "desc"
                }
            })
        }
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
        async exportReports() {
            // Use fetch() directly so Inertia's global event listeners cannot
            // intercept the request. The response blob is turned into a
            // temporary object URL and clicked programmatically to trigger the
            // browser's native file download without any page navigation.
            const f = this.form.filter;
            const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

            const body = new URLSearchParams({
                '_token': csrfToken,
                'filter[status]': f.status ?? '',
                'filter[organisation]': f.organisation ?? '',
                'filter[office]': f.office ?? '',
                'filter[manager]': f.manager ?? '',
                'filter[project_type]': f.project_type ?? '',
                'filter[starts_at]': f.starts_at ?? '',
                'filter[ends_at]': f.ends_at ?? '',
            });

            this.exporting = true;

            try {
                const response = await fetch('/reports/download', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'X-CSRF-TOKEN': csrfToken,
                        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/octet-stream,application/json',
                    },
                    credentials: 'same-origin',
                    body: body.toString(),
                });

                if (!response.ok) {
                    const errorType = (response.headers.get('content-type') || '').toLowerCase();
                    if (errorType.includes('application/json')) {
                        const payload = await response.json();
                        throw new Error(payload.message || 'Export request failed.');
                    }
                    throw new Error('Export request failed with status ' + response.status);
                }

                const contentType = (response.headers.get('content-type') || '').toLowerCase();
                const disposition = response.headers.get('content-disposition') || '';
                const isAttachment = disposition.toLowerCase().includes('attachment');
                const isSpreadsheet = contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
                    || contentType.includes('application/octet-stream')
                    || disposition.toLowerCase().includes('.xlsx');

                if (!isAttachment || !isSpreadsheet) {
                    const errorText = await response.text();
                    throw new Error(errorText || 'The server did not return an Excel file.');
                }

                const blob = await response.blob();
                const filenameMatch = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
                const filename = filenameMatch ? filenameMatch[1].replace(/['"]/g, '') : 'project-reports.xlsx';

                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            } catch (error) {
                console.error('Export failed:', error);
                alert(error?.message || 'Export failed. Please adjust your filters and try again.');
            } finally {
                this.exporting = false;
            }
        },
    },
    watch: {
        form: {
            deep: true,
            handler: debounce(function () {
                this.$inertia.get(route('frontend.reports.index'), pickBy(this.form), {preserveState: true})
            }, 500),
        },
    }
}
</script>
